
/**
 * 问卷数据列表
 */

 export const QuestionDataList=[
    {
        prop:"id",
        label:"id",
        width:"150",
        format: "",
        order: false,
        isShow:false
    },
    {
        prop:"title",
        label:"问卷标题",
        width:"500",
        format: "",
        order: false,
        isShow:true
    },
    {
        prop:"participationCount",
        label:"参与人数",
        width:"150",
        format: "",
        order: false,
        isShow:true
    },
    {
        prop:"status",
        label:"状态",
        width:"150",
        format: "status",
        order: false,
        isShow:true
    },
    {
        prop: "createTime",
        label: "创建时间",
        width: "200",
        format: "datetime",
        order: true,
        isShow: true
    }
 ]

